/**
 * Der Pfad, unter dem die Oberflaeche liegt, mit abschliessendem "/".
 *
 * Ein Produktionsbuild wird mit relativen Pfaden gebaut (``base: "./"`` in
 * vite.config.ts). Dann ist ``import.meta.env.BASE_URL`` ein relativer Wert,
 * und der tatsaechliche Ordner ergibt sich erst auf dem Server - etwa
 * ``/Sascha.Selkmann/`` auf einer persoenlichen Homepage. Er wird deshalb aus
 * der Adresse dieses Moduls abgeleitet: im Build liegt es im Ordner
 * ``assets/`` direkt unter der Oberflaeche, eine Ebene tiefer.
 *
 * Ist ``BASE_URL`` beim Bauen ausdruecklich als absoluter Pfad gesetzt, gilt
 * dieser. Entwicklungsserver und Tests benutzen "/".
 */
export const berechneBasis = (
  konfiguriert: string | undefined,
  modulAdresse: string
): string => {
  let base = konfiguriert || "/";
  if (!base.startsWith("/")) {
    base = new URL("..", modulAdresse).pathname;
  }
  if (!base.endsWith("/")) {
    base += "/";
  }
  return base;
};

export const baseUrl = berechneBasis(import.meta.env.BASE_URL, import.meta.url);
